/**
 * Date-extensions locale Chuvash [cv]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('cv', {
    monthNames: ['кӑрлач','нарӑс','пуш','ака','май','ҫӗртме','утӑ','ҫурла','авӑн','юпа','чӳк','раштав'],
    monthShortNames: ['кӑр','нар','пуш','ака','май','ҫӗр','утӑ','ҫур','авн','юпа','чӳк','раш'],
    dayNames: ['вырсарникун','тунтикун','ытларикун','юнкун','кӗҫнерникун','эрнекун','шӑматкун'],
    dayShortNames: ['выр','тун','ытл','юн','кӗҫ','эрн','шӑм']
});
